<template>
    <div class="stats__blocks">
        <div class="stats-block">
            <div class="stats-block__top">
                <div class="stats-block__top-title">Зарегистрированных <br> новых поставщиков</div>
                <div class="stats-block__top-actions">
                    <div v-if="supplierBlocks.newUsersCount"  class="dots-action"> 
                        <div class="dots-action__list">
                            <div class="dots-action__item" @click="handleOpenStatsPopup('Новые поставщики', 'new-suppliers')">Подробнее</div>
                            <div class="dots-action__item" @click="downloadLink('new-suppliers')">Выгрузить статистику</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stats-block__total">{{ supplierBlocks.newUsersCount || 0}}</div>
        </div>        
        <div class="stats-block">
            <div class="stats-block__top">
                <div class="stats-block__top-title">Поставщиков, принявших <br> участие в тендере</div>
                <div class="stats-block__top-actions">
                    <div v-if="supplierBlocks.tenderParticipantsCount" class="dots-action">
                        <div class="dots-action__list">
                           <div  class="dots-action__item" @click="handleOpenStatsPopup('Участники тендеров', 'tenders-participants')">Подробнее</div>
                            <div class="dots-action__item" @click="downloadLink('tenders-participants')">Выгрузить статистику</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stats-block__total">{{ supplierBlocks.tenderParticipantsCount || 0 }}</div>
        </div>  
        <div class="stats-block">
            <div class="stats-block__top">
                <div class="stats-block__top-title">Количество <br> тендеров</div>
                <div class="stats-block__top-actions">
                    <div v-if="supplierBlocks.tendersCount"  class="dots-action">
                        <div class="dots-action__list">
                            <div class="dots-action__item" @click="handleOpenStatsPopup('Тендеры', 'current-tenders')">Подробнее</div>
                            <div class="dots-action__item" @click="downloadLink('current-tenders')">Выгрузить статистику</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stats-block__total">{{ supplierBlocks.tendersCount || 0 }}</div>
        </div>
        <div class="stats-block">
            <div class="stats-block__top">
                <div class="stats-block__top-title">Количество коммерческих <br> предложений</div>
                <div class="stats-block__top-actions">
                    <div v-if="supplierBlocks.commercialOffersCount" class="dots-action">
                        <div class="dots-action__list">
                            <div  class="dots-action__item" @click="handleOpenStatsPopup('Коммерческие предложения', 'current-commercial-offers')">Подробнее</div>
                            <div class="dots-action__item" @click="downloadLink('current-commercial-offers')">Выгрузить статистику</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stats-block__total">{{ supplierBlocks.commercialOffersCount || 0 }}</div>
        </div>
    </div>
	<transition-group name="modal">
		<StatsBlockPopup v-if="ShowStatsBlockPopup" @close="ShowStatsBlockPopup = false" :selectedSupplierBlock="selectedSupplierBlock"/>
	</transition-group>
</template>



<script>
import { mapGetters } from 'vuex';
import { useToast } from "vue-toastification";
import StatsBlockPopup from "@/components/sections/Stats/StatsBlockPopup.vue";

export default {
    name: "StatsHead",
    props: {
        supplierBlocks: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    components: { StatsBlockPopup },
	data() {
		return {
			toast: useToast(),
            ShowStatsBlockPopup: false,
            selectedSupplierBlock: null
		}
	},
    computed: {
        ...mapGetters({
			supplierFilter: 'stats/getSupplierFilter',
		})
    },
    methods: {
        handleOpenStatsPopup(title,key) {
			this.selectedSupplierBlock = {
                title,
                key
            }
			this.ShowStatsBlockPopup = true
		},
        downloadLink(id) {
            window.open(`${window?.location?.origin}/api/tenders/stats/${id}/export/excel/${this.supplierFilter.dateFrom ? `?dateFrom=${this.supplierFilter.dateFrom}&dateTo=${this.supplierFilter.dateTo}` : ''}`)
        },
    },

}
</script>